<template>
  <CustomModal
    :show="showModal" 
    @closeModal="$emit('close')" 
    size="sm"
    @shown="showModal? $refs.description.focus() : null">
    <template #modal-header>
      Tax Fund Entry - {{mode}}
    </template>
    <template #modal-body>
      <b-form autocomplete="off">
        <b-form-group>
          <label class="required">Description</label>
          <b-form-textarea
            ref="description"
            v-model="form.fields.description"
            :state="form.states.description"
            debounce="250"
            type="text" />
          <b-form-invalid-feedback>
            {{form.errors.description}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <label>Debit</label>
          <v-autonumeric
            :disabled ="form.fields.credit > 0"
            class="form-control text-right"
            :class=" { 'is-invalid' : !!form.errors.debit  }"
            v-model="form.fields.debit"
            :options="{
              minimumValue: '0',
              modifyValueOnWheel: false,
              emptyInputBehavior: 0
            }"
            debounce="500"/>
            <b-form-invalid-feedback>
              {{form.errors.debit}}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <label>Credit</label>
          <v-autonumeric
            :disabled ="form.fields.debit > 0"
            class="form-control text-right"
            v-model="form.fields.credit"
            :class=" { 'is-invalid' : !!form.errors.credit  }"
            :options="{
              minimumValue: '0',
              modifyValueOnWheel: false,
              emptyInputBehavior: 0
            }"
            debounce="500"/>
            <b-form-invalid-feedback>
              {{form.errors.credit}}
            </b-form-invalid-feedback>
        </b-form-group>
      </b-form>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <SaveButton @click="$emit('save')" :isProcessing="form.isProcessing"/>
        <CloseButton @click="$emit('close')" class="ml-2" :isProcessing="form.isProcessing"/>
      </div>
    </template>
  </CustomModal>
</template>
<script>
import { SaveButton, CloseButton } from '../../components'
import CustomModal from '../../components/CustomModal.vue'
export default {
  components: {
    SaveButton, CloseButton,
    CustomModal
  },
  props: {
    show: Boolean,
    form: Object,
    mode: String
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  
</style>